import {actions, ActionType} from './action';
import {
  createBasicReducerHandlers,
  createReducer,
  ReducerActionHelper,
} from '../../common/util/redux';
import {ISearchGenre, ISearchResult, ISearchSuggest} from '../type';

export interface IStateSearch {
  genres: ISearchGenre[];
  suggest: ISearchSuggest;
  result: ISearchResult;
}

const INITIAL_STATE: IStateSearch = {
  genres: [],
  suggest: {},
  result: {
    contents: [],
    totalCount: 0,
  },
};

export default createReducer<IStateSearch, ReducerActionHelper<typeof actions>>(
  INITIAL_STATE,
  {
    ...createBasicReducerHandlers({
      setValueActionType: ActionType.SetValue,
      setPropertyValuesActionType: ActionType.SetPropertyValues,
    }),
    [ActionType.ResetResult]: state => {
      state.result = INITIAL_STATE.result;
    },
    [ActionType.AddResult]: (state, action) => {
      const {result, isFirst} = action.payload;
      const {contents} = result;
      if (isFirst) {
        state.result = result;
      } else {
        state.result.contents.push(...contents);
      }
    },
  }
);
